var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonicIosInformationCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.093,
    height: 12.093,
    viewBox: "0 0 12.093 12.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-information-circle-outline",
    "data-name": "Icon ionic-ios-information-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50608",
    "data-name": "Path 50608",
    d: "M16.552,11.287a.6.6,0,1,1,.6.581A.582.582,0,0,1,16.552,11.287Zm.041,1.038H17.7v4.189H16.592Z",
    transform: "translate(-7.729 -4.302)",
    fill: "#30B524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50609",
    "data-name": "Path 50609",
    d: "M9.422,4.189a5.231,5.231,0,1,1-3.7,1.532,5.2,5.2,0,0,1,3.7-1.532m0-.814a6.047,6.047,0,1,0,6.047,6.047A6.046,6.046,0,0,0,9.422,3.375Z",
    fill: "#30B524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicIosInformationCircleOutline);
export default __webpack_public_path__ + "static/media/ionic-ios-information-circle-outline.da01c2e4c1a740b3b214d5923afa0b9b.svg";
export { ForwardRef as ReactComponent };